export default __webpack_public_path__ + "images/KV.20dcf50.png";